import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { filterChange } from '../../../actions/index';

import Grid from '@material-ui/core/Grid';
import Slider from '@material-ui/core/Slider';
import CloseIcon from '@material-ui/icons/Close';

import { _ } from '../../../functions/translator.js';
import { FilterActions } from '../../../constants/constants.js';

class SurfaceDropdown extends React.Component{

    constructor(props) {
        super(props)
        this.state = {
            defaultValue: null,
            initialValues: this.getSurfaceMinAndMax(),
            surfaceValues: this.getSurfaceMinAndMax(),
        }
    }

    handleSurfaceChange = (event, newValue) => {
        this.setState({ surfaceValues: newValue });
        this.props.filterChange(FilterActions.SURFACE, newValue);
    };

    handleClose = (event) => {
        this.props.filterChange(FilterActions.SURFACE, this.state.defaultValue);
        this.props.closeCallback(event);
    }

    getSurfaceMinAndMax = () => {
        let min = 0;
        let max = 1;
        for (const figureData of Object.values(this.props.figuresData)) {
            const surface = figureData.attributes.real_surface;
            if (!surface) continue;
            if (min > surface) min = surface;
            if (max < surface) max = surface;
        }
        return [min, max];
    }

    render() {
        return(
            <div className={this.props.extraClass}>
                <p className='text'>
                    { _('Superficie') } (m2)
                    <CloseIcon className='float-right cursor-pointer' data-type='surface' onClick={this.handleClose}/>
                </p>
                <Grid container spacing={2}>
                    <Grid item>
                        {Math.round(this.state.initialValues[0])}
                    </Grid>
                    <Grid item xs>
                        <Slider
                            min={this.state.initialValues[0]}
                            max={this.state.initialValues[1]}
                            value={this.state.surfaceValues}
                            onChange={this.handleSurfaceChange}
                            valueLabelDisplay="auto"
                            valueLabelFormat={(value) => `${Math.round(value)}`}
                        />
                    </Grid>
                    <Grid item>
                        {Math.round(this.state.initialValues[1])}
                    </Grid>
                </Grid>
            </div>
        );
    }
}

function mapStateToProps( state ){
    return {
        figuresData : state.projectData.figures
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({ 
        filterChange     : filterChange
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(SurfaceDropdown);